import React, { useEffect } from 'react';
import Animated from 'react-native-reanimated';
import { StyleSheet, View } from 'react-native';
import Text from 'design-system/Text';
import Spacer from 'design-system/Spacer';
import { AppView } from 'design-system/AppView';
import Indicator from 'design-system/Indicator';
import { rem, SCROLL_INDICATOR_INSETS } from 'design-system/values';
import withAnimatedNavigationHeader from 'design-system/hoc/withAnimatedNavigationHeader';
import { useMarginBottom } from 'hooks/useMarginBottom';
import { useAppDispatch, useAppSelector } from 'store/hooks';
import useAppFrameDimensions from 'hooks/useAppFrameDimensions';
import { getAnalystRatingsDetails } from '../actions';
import AnalystDetailsCard from '../components/AnalystDetailsCard';
import { isWeb } from '../../../constants';
const InvestAnalystRatingsDetails = withAnimatedNavigationHeader(({ route, scrollHandler }) => {
    const { assetId } = route.params;
    const dispatch = useAppDispatch();
    const { paddingHorizontalStyle } = useAppFrameDimensions(isWeb);
    const contentContainerStyle = useMarginBottom('paddingBottom', undefined, paddingHorizontalStyle);
    const analystRatingsDetails = useAppSelector((state) => state.unpersistedInvestReducer.analystInfoDetailsMap?.[assetId]);
    useEffect(() => {
        dispatch(getAnalystRatingsDetails(assetId));
    }, [assetId]);
    if (!analystRatingsDetails || Object.keys(analystRatingsDetails).length !== 8) {
        return (<AppView testID="loadingView">
          <Indicator dark includeHeaderHeight/>
        </AppView>);
    }
    return (<AppView type="secondary" withFrame={false} testID="screen">
        <Animated.ScrollView scrollEventThrottle={16} onScroll={scrollHandler} contentContainerStyle={contentContainerStyle} scrollIndicatorInsets={SCROLL_INDICATOR_INSETS}>
          <AnalystDetailsCard analystRatingsDetails={analystRatingsDetails}/>
          <Spacer h={24}/>
          <View style={styles.footerContainer}>
            <Text TextThin-12 Secondary>
              {'Analyst ratings show Buy, Hold, and Sell recommendations from analysts at third party brokers.\n\nThese ratings are opinions on the stock’s future performance based on independent analysis on the company’s financials (e.g. sales, profit, debt and growth).\n\nThese ratings should not be seen as investment advice. However, the more resources and data you take into account, the more informed your investment decisions may be. '}
            </Text>
          </View>
        </Animated.ScrollView>
      </AppView>);
}, ({ colors }) => ({
    title: 'Analyst ratings',
    headerColorOutputRange: [colors.background.dark, colors.cards.onDark],
}));
const styles = StyleSheet.create({
    footerContainer: {
        paddingHorizontal: rem(16),
    },
});
export default InvestAnalystRatingsDetails;
